import { DateUtility, DateFormat } from '@utility/date';
import { useEffect, useMemo, useState } from 'react';
import { cn } from '@skupreme/shared/ui';
import { differenceInDays } from './common';

const DATE_CELL =
  'sk:absolute sk:box-border sk:border-solid sk:border-rule sk:select-none';

export function DatesBar({
  DayWidth,
  marginLeft = 0,
  startDate,
  endDate,
  differenceInHours = 0,
  hourWidth = 0,
  chartRef,
}) {
  const [weeks, setWeeks] = useState([]);
  const [days, setDays] = useState([]);
  const difference = useMemo(
    () => DateUtility.difference(startDate, endDate),
    [startDate, endDate],
  );

  const toSkip = 7;

  useEffect(() => {
    if (!difference || difference < 1) return;

    if (!startDate || !endDate) return;
    const arr = [DateUtility.formatDate(startDate, DateFormat.date)];

    let currentDate = startDate;
    let isDateAfter = true;
    while (isDateAfter) {
      const nextDate = DateUtility.addDays(currentDate, toSkip);
      if (DateUtility.isDateAfter(nextDate, endDate)) {
        isDateAfter = false;
        break;
      }
      arr.push(DateUtility.formatDate(nextDate, DateFormat.date));
      currentDate = nextDate;
    }
    // @ts-expect-error - TS2345: Argument of type 'string[]' is not assignable to parameter of type 'SetStateActi...
    setWeeks(arr);
  }, [startDate, endDate]);

  useEffect(() => {
    if (!difference || difference < 1) return;

    let date = startDate;
    const arr = new Array(difference);
    const currentDate = DateUtility.formatDate(
      new Date(),
      DateFormat.yearMonthDate,
    );
    for (let i = 0; i < difference; i += 1) {
      const weekDayName = DateUtility.formatDate(date, DateFormat.day);
      const nextDate = DateUtility.formatDate(date, DateFormat.yearMonthDate);
      if (DateUtility.difference(currentDate, nextDate) === 0) {
        arr[i] = <b>{weekDayName[0]}</b>;
      } else {
        arr[i] = weekDayName[0];
      }
      date = DateUtility.addDays(date, 1);
    }

    // @ts-expect-error - TS2345: Argument of type 'any[]' is not assignable to parameter of type 'SetStateAction<...
    setDays(arr);
  }, [difference]);

  const spaceFromLeft = useMemo(
    () => differenceInDays(startDate, new Date()) * DayWidth,
    [startDate],
  );

  if (!difference) return <text>loading</text>;

  return (
    <>
      <div className="sk:relative sk:top-0 sk:z-10 sk:ml-52 sk:h-10 sk:select-none">
        {weeks.map((weekDate, index) => (
          <div
            className={cn(
              DATE_CELL,
              'sk:h-5 sk:bg-surface sk:pl-1 sk:[border-width:0_1px_0_0]',
            )}
            style={{
              width: DayWidth * 7,
              left:
                index * (DayWidth * 7) +
                marginLeft -
                differenceInHours * hourWidth,
            }}
          >
            {weekDate}
          </div>
        ))}
        {days.map((weekDate, index) => (
          <div
            className={cn(
              DATE_CELL,
              'sk:top-5 sk:-z-1 sk:text-center sk:[border-width:1px_1px_0_0]',
            )}
            style={{
              width: DayWidth,
              height: chartRef?.current?.scrollHeight - 30 || 70,
              left:
                index * DayWidth + marginLeft - differenceInHours * hourWidth,
            }}
          >
            {weekDate}
          </div>
        ))}
        <div
          className="sk:absolute sk:bg-fill-secondary"
          style={{
            width: spaceFromLeft,
            height: chartRef?.current?.scrollHeight - 10 || 70,
          }}
        />
      </div>
      <div className="sk:sticky sk:top-10 sk:z-19">
        <div
          className="sk:absolute sk:-mt-10 sk:h-[calc(86vh-20px)] sk:w-0.5 sk:bg-fg"
          style={{ left: spaceFromLeft + 208 }}
        />
        <div
          className="sk:absolute sk:top-1.25 sk:rounded-[5px] sk:bg-surface/70 sk:px-1.25 sk:py-px sk:font-bold sk:backdrop-blur-[2px]"
          style={{ left: spaceFromLeft + 210 }}
        >
          Today
        </div>
      </div>
    </>
  );
}
